export default {    
    form: {        
        fields: {            
            condicao: {
                fields: {
                    firstField: {
                        label: "Campo",
                        description: "Qual será o campo para validar."
                    },
                    rule: {
                        label: "Condição",
                        description: "Qual será a Condição."
                    },
                    secondField: {
                        label: "Valor",
                        description: "Qual será o valor para comparar."
                    },
                    thirdField: {
                        label: "Outro Valor",
                        description: "Qual será o outro valor para comparar."
                    },
                    fourthField: {
                        label: "Resultado",
                        description: "Qual será o valor do resultado."
                    }                    
                },
                DB_fields: {                    
                    value_quantity_value: "Valor do resultado"                    
                },
                rules: {
                    isNull: "Está vazio",
                    isNotNull: "Não está vazio",
                    bigger: "Maior que",
                    biggerOrEqual: "Maior ou igual a",
                    less: "Menor que",
                    lessOrEqual: "Menor ou igual a",
                    equal: "é igual a",
                    different: "é diferente de",
                    between: "Está entre",
                    notBetween: "Não está entre"
                }
            }
        },
        buttons: {
            adicionar_condicao: 'Adicionar Condição',
            remover_condicao: 'Remover Condição',
            salvar: 'Salvar Condição'
        },
        create: {
            success: "Condição criada com Sucesso!",
            error: "Error ao criar condição!"
        },
        update: {
            success: "Condição editada com Sucesso!",
            error: "Error ao editar condição!"
        }
    }
}
